import { DialogTitle } from '@aibees/shared/components';
import { useBoolean } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { DialogContent } from '@mui/material';
import { memo, useEffect, useState } from 'react';
import { SubscriptionModalType } from '../../types';
import { DialogFooter } from './components/dialog-footer';
import * as Styled from './styles';
import * as SX from './sx';
import type { SubscriptionFeedbackDialogProps as Props } from './types';

export const SubscriptionFeedbackDialog = memo(
  ({ className, activeModal, closeModal, onCancel, onConfirm }: Props) => {
    const state = useBoolean(false);
    const [comment, setComment] = useState<string>('');

    useEffect(() => {
      state.setValue(activeModal === SubscriptionModalType.COLLECT_FEEDBACK);
    }, [activeModal, state]);

    return (
      <Styled.Wrapper
        open={state.value}
        onClose={closeModal}
        className={classnames('SubscriptionFeedbackDialog', className)}
        sx={SX.root}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle title="Just a Moment Before You Go" onClose={closeModal} />
        <DialogContent>
          <Styled.TextArea
            minRows={4}
            maxRows={4}
            placeholder="Please share anything you love and find awesome using AI Ark."
            onChange={(event) => setComment(event.target.value)}
          />
        </DialogContent>
        <DialogFooter
          closeModal={closeModal}
          onCancel={onCancel}
          onConfirm={() => onConfirm?.(comment)}
        />
      </Styled.Wrapper>
    );
  }
);

SubscriptionFeedbackDialog.displayName = 'SubscriptionFeedbackDialog';
